<template>
  <div class="page">
    <div class="title">账单信息：</div>
    <div class="item">
      <div class="name"><span class="t_red">*</span> 团号</div>
      <div class="inp" @click="openSlectPath()">
        {{ form.groupNo }}
      </div>
    </div>
    <div class="item">
      <div class="name"><span class="t_red">*</span> 账单类型</div>
      <div class="inp">
        <!-- <select v-modal="form.billType">
          <option :value="item" v-for="(item,index) in BillTypeOptions" :key="index">{{item}}</option>
        </select> -->
        <v-select
          style="width: 100%"
          v-model="form.billType"
          :options="BillTypeOptions"
        ></v-select>
      </div>
    </div>
    <div class="item" @click="calendarShow = true">
      <div class="name"><span class="t_red">*</span> 账单时间</div>
      <div class="inp">
        {{
          form.happenDate ? moment(form.happenDate).format("YYYY-MM-DD") : ""
        }}
      </div>
    </div>
    <div class="item">
      <div class="name"><span class="t_red">*</span> 账单价格（元）</div>
      <div class="inp">
        <input class="content" type="number" v-model="form.price" />
      </div>
    </div>
    <div class="item">
      <div class="name"><span class="t_red">*</span> 账单内容</div>
      <div class="inp">
        <input class="content" v-model="form.billContent" />
      </div>
    </div>
    <div class="item">
      <div class="name"><span class="t_red">*</span> 账单图片</div>
      <div class="inp">
        <div class="imgs">
          <div
            class="img"
            v-for="(item, index) in form.billImages"
            :key="index"
          >
            <img style="margin-right: 10px" :src="item" />
            <van-icon class="del" name="cross" @click="delImag(index)" />
          </div>

          <Uploader
            v-bind:url="remoteUrl"
            v-bind:data="formData"
            v-bind:type="1"
            @success="uploadSuccess($event)"
            @error="uploadError($event)"
            v-if="initOssEnd"
          >
          </Uploader>
        </div>
      </div>
    </div>

    <div class="sub" @click="saveBills()">保存</div>
    <selectPath ref="selectPath" @getData="getPath" />
    <calendar :show.sync="calendarShow" @change="onChange" />
  </div>
</template>

<script>
import appService from "@/services/request/appService";
import store from "store";
import QRCode from "qrcodejs2";
import { Dialog } from "vant";
import moment from "moment";
import selectPath from "../common/selectPath";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Uploader from "../common/Uploader";
// import Calendar from 'vue-mobile-calendar';
export default {
  name: "BigDataEdit",
  components: {
    Dialog,
    selectPath,
    vSelect,
    Uploader,
    // Calendar
  },
  data() {
    return {
      moment: moment,
      params: {
        iid: this.$route.query.iid || "",
        userId: "",
        status: 0,
        queryKey: "",
        pageNumber: 1,
        pageSize: 10,
      },
      data: [],
      BillTypeOptions: [
        "导游费",
        "服务费",
        "住宿费",
        "餐饮费",
        "营销费",
        "报账款",
        "采购费",
      ],
      form: {
        billContent: "",
        billImages: [],
        billType: "",
        price: "",
        groupNo: "",
        happenDate: "",
      },
      remoteUrl: "",
      formData: {},
      initOssEnd: false,
      calendarShow: false,
    };
  },
  mounted: function () {
    document.title = this.$route.query.id ? "报帐编辑" : "报帐添加";
    this.initOssParams();
    if (this.$route.query.id) {
      this.getDetail();
    }
  },
  methods: {
    onChange(date) {
      this.form.happenDate = new Date(date).getTime();
      this.calendarShow = false;
    },
    initOssParams() {
      appService.getOssParams().then(
        (result) => {
          var ossInfo = result;
          var key = "h5/" + this.$route.query.iid + "_" + new Date().getTime();
          this.remoteUrl = "https://fimage.oss-cn-shenzhen.aliyuncs.com/";
          this.formData = {
            key: key,
            policy: ossInfo.policy,
            OSSAccessKeyId: ossInfo.accessKeyId,
            success_action_status: "200", //让服务端返回200,不然，默认会返回204
            signature: ossInfo.sign,
            expire_time: ossInfo.expireTime,
          };
          this.initOssEnd = true;
        },
        (error) => {}
      );
    },
    uploadSuccess(res) {
      if (res && res.previewUrl) {
        this.form.billImages.push(res.previewUrl);
      }
    },
    uploadError(res) {
      console.log("上传失败");
    },
    delImag(index) {
      this.form.billImages.splice(index, 1);
    },
    getDetail() {
      appService
        .getBillsDetail({
          id: this.$route.query.id,
          iid: this.$route.query.iid,
          userId: store.get("loginData").rid || "",
        })
        .then(
          (result) => {
            console.log("result", result);
            try {
              result.billImages = JSON.parse(result.billImages);
            } catch (error) {
              result.billImages = []
            }
            
            this.form = result;
          },
          (error) => {}
        );
    },
    openSlectPath() {
      this.$refs.selectPath.isShow = true;
    },
    getPath(data) {
      console.log(data);
      this.form.groupNo = data.groupNo;
    },
    async saveBills() {
      let params = JSON.parse(JSON.stringify(this.form));
      params.billImages = JSON.stringify(params.billImages);
      params.userId = store.get("loginData").rid || "";
      params.iid = this.$route.query.iid || "";
      appService.saveBills(params).then(
        (result) => {
          console.log(result);
          if (!result.code) {
            if (params.id) {
              this.$toast("修改成功！");
            } else {
              this.$toast("添加成功！");
            }

            history.go(-1);
          } else {
            this.$toast.fail(result.msg);
          }
        },
        (error) => {}
      );
    },
  },
};
</script>

<style scoped lang="less">
.page {
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  padding: 0.36rem;
  box-sizing: border-box;
  background: #fff;
  overflow-y: scroll;
  .item {
    padding-top: 0.32rem;
    padding-bottom: 0.32rem;
    .name {
      font-size: 0.28rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 0.4rem;
      .t_red {
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #e02020;
        line-height: 0.34rem;
      }
    }
    .inp {
      padding-bottom: 0.05rem;
      border-bottom: 0.02rem solid #e2e2e2;
      margin-top: 0.11rem;
      display: flex;
      min-height: 17px;
      padding-left: 0.2rem;
      box-sizing: border-box;
      .content {
        border: none;
        height: 100%;
        width: 100%;
        -webkit-appearance: none;
        background: none;
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        // color: #999999;
        line-height: 0.5rem;
      }
      .imgs {
        display: flex;
        flex-wrap: wrap;
        .img {
          position: relative;
          img {
            width: 1.72rem;
            height: 1.72rem;
            background: #f9f9f9;
            border-radius: 0.12rem;
            border: 0.02rem solid #e2e2e2;
          }
          .del {
            position: absolute;
            right: 0;
            top: 0;
            color: red;
            font-weight: 800;
          }
        }
      }
    }
  }
  .sub {
    width: 6.76rem;
    height: 0.84rem;
    background: linear-gradient(180deg, #26d3a1 0%, #24a785 100%);
    border-radius: 0.12rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.32rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 0.44rem;
  }
}
</style>
